module.exports = __webpack_public_path__ + "assets/logo_designing.35365a74.svg";